import React from 'react';
import CharacterPortrait from './CharacterPortrait';
import type { PortraitVariantSize } from '../../types/portrait';

export interface PortraitImageProps {
  portraitId?: string;
  variant?: PortraitVariantSize;
  alt?: string;
  className?: string;
  lazy?: boolean;
}

const buildClassName = (
  variant: PortraitVariantSize,
  className?: string
): string => {
  const classes = [
    'rich-text-image',
    'rich-text-portrait',
    `rich-text-portrait-${variant}`,
    className?.trim() ?? ''
  ].filter(Boolean);

  return classes.join(' ');
};

const PortraitImage: React.FC<PortraitImageProps> = ({
  portraitId,
  variant = 'card',
  alt,
  className,
  lazy = true
}) => {
  return (
    <CharacterPortrait
      portraitId={portraitId}
      variant={variant}
      alt={alt ?? ''}
      className={buildClassName(variant, className)}
      lazy={lazy}
    />
  );
};

export default PortraitImage;


